import { version } from '../package.json';
import { packages as pkgList } from './config.json';
import { locale } from './locales';

import Icon from './packages/icon/index.js';
import './packages/icon/icon.scss';

import Switch from './packages/switch/index.js';
import './packages/switch/switch.scss';

import Button from './packages/button/index.js';
import './packages/button/button.scss';

import ButtonGroup from './packages/buttongroup/index.js';
import './packages/buttongroup/buttongroup.scss';

import Lazyload from './packages/lazyload/index.js';
import './packages/lazyload/lazyload.scss';

import Popup from './packages/popup/index.js';
import './packages/popup/popup.scss';

import Cell from './packages/cell/index.js';
import './packages/cell/cell.scss';

import NavBar from './packages/navbar/index.js';
import './packages/navbar/navbar.scss';

import Tag from './packages/tag/index.js';
import './packages/tag/tag.scss';

import NoticeBar from './packages/noticebar/index.js';
import './packages/noticebar/noticebar.scss';

import Overlay from './packages/overlay/index.js';
import './packages/overlay/overlay.scss';

import Modal from './packages/modal/index.js';
import './packages/modal/modal.scss';

import Dialog from './packages/dialog/index.js';
import './packages/dialog/dialog.scss';

import SearchBar from './packages/searchbar/index.js';
import './packages/searchbar/searchbar.scss';

import Empty from './packages/empty/index.js';
import './packages/empty/empty.scss';

import ScrollView from './packages/scrollview/index.js';
import './packages/scrollview/scrollview.scss';
import Picker from './packages/picker/index.js';
import './packages/picker/picker.scss';

import Checkbox from './packages/checkbox/index.js';
import './packages/checkbox/checkbox.scss';

import Radio from './packages/radio/index.js';
import './packages/radio/radio.scss';

import Rate from './packages/rate/index.js';
import './packages/rate/rate.scss';

import PickerColumn from './packages/pickercolumn/index.js';
import './packages/pickercolumn/pickercolumn.scss';

import DateTimePicker from './packages/datetimepicker/index.js';
import './packages/datetimepicker/datetimepicker.scss';

import Badge from './packages/badge/index.js';
import './packages/badge/badge.scss';

import Mask from './packages/mask/index.js';
import './packages/mask/mask.scss';

import ActionSheet from './packages/actionsheet/index.js';
import './packages/actionsheet/actionsheet.scss';

import Toast from './packages/toast/index.js';
import './packages/toast/toast.scss';

import TabBar from './packages/tabbar/index.js';
import './packages/tabbar/tabbar.scss';

import TabBarItem from './packages/tabbaritem/index.js';
import './packages/tabbaritem/tabbaritem.scss';

import Tab from './packages/tab/index.js';
import './packages/tab/tab.scss';

import TabPane from './packages/tabpane/index.js';
import './packages/tabpane/tabpane.scss';

import Catalog from './packages/catalog/index.js';
import './packages/catalog/catalog.scss';

import Slider from './packages/slider/index.js';
import './packages/slider/slider.scss';

import SliderScale from './packages/sliderscale/index.js';
import './packages/sliderscale/sliderscale.scss';

import PullRefresh from './packages/pullrefresh/index.js';
import './packages/pullrefresh/pullrefresh.scss';

import Loading from './packages/loading/index.js';
import './packages/loading/loading.scss';

import Swiper from './packages/swiper/index.js';
import './packages/swiper/swiper.scss';

import SwiperItem from './packages/swiperitem/index.js';
import './packages/swiperitem/swiperitem.scss';

import List from './packages/list/index.js';
import './packages/list/list.scss';

import Steps from './packages/steps/index';
import './packages/steps/steps.scss';

import Step from './packages/step/index';
import './packages/step/step.scss';

import ChartLine from './packages/chartline/index';
import './packages/chartline/chartline.scss';

import ChartColumn from './packages/chartcolumn/index';
import './packages/chartcolumn/chartcolumn.scss';

import ChartPie from './packages/chartpie/index';
import './packages/chartpie/chartpie.scss';

import Sticky from './packages/sticky/index';
import './packages/sticky/sticky.scss';

import Collapse from './packages/collapse/index'
import './packages/collapse/collapse.scss'

import CollapseItem from './packages/collapseitem/index'
import './packages/collapseitem/collapseitem.scss'

const packages = {
  Icon,
  Switch,
  Button,
  ButtonGroup,
  Popup,
  Cell,
  Tag,
  NavBar,
  NoticeBar,
  Overlay,
  Modal,
  Dialog,
  SearchBar,
  Empty,
  ScrollView,
  Checkbox,
  Radio,
  Rate,
  Picker,
  PickerColumn,
  DateTimePicker,
  Badge,
  Mask,
  ActionSheet,
  Toast,
  TabBar,
  TabBarItem,
  Tab,
  TabPane,
  Catalog,
  Slider,
  SliderScale,
  PullRefresh,
  Loading,
  Swiper,
  SwiperItem,
  List,
  Steps,
  Step,
  ChartLine,
  ChartColumn,
  ChartPie,
  Sticky,
  Collapse,
  CollapseItem,
};

const components = {};
const methods = {};
const filters = {};
const directives = {};
pkgList.map((item) => {
  const pkg = packages[item.name];

  if (!pkg) return;

  if (item.type == 'component') {
    if (pkg.name) {
      components[pkg.name] = pkg;
    } else {
      for (let n in pkg) {
        components[n] = pkg[n];
      }
    }
  } else if (item.type == 'method') {
    methods[item.name] = pkg;
  } else if (item.type == 'filter') {
    filters[item.name] = pkg;
  } else if (item.type == 'directive') {
    directives[item.name] = pkg;
  }
});

const install = function (Vue, opts = {}) {
  if (install.installed) return;

  if (opts.locale) {
    Vue.config.lang = opts.locale;
  }

  if (opts.lang) locale(Vue.config.lang, opts.lang);

  for (let cptName in methods) {
    if (Array.isArray(methods[cptName])) {
      Vue.prototype['$' + cptName.toLowerCase()] = methods[cptName][0];
      Vue.component(methods[cptName][1].name, methods[cptName][1]);
    } else {
      Vue.prototype['$' + cptName.toLowerCase()] = methods[cptName];
    }
  }

  for (let cptName in components) {
    if (components[cptName] && components[cptName].name) {
      Vue.use(components[cptName])
    }
  }

  for (let cptName in filters) {
    if (filters[cptName] && filters[cptName].name) {
      Vue.filter(cptName, filters[cptName]);
    }
  }

  for (let cptName in directives) {
    if (directives[cptName] && directives[cptName].name) {
      Vue.directive(directives[cptName].name, directives[cptName]);
    }
  }

  Vue.use(Lazyload, {
    lazyComponent: true,
    loading: '//img12.360buyimg.com/imagetools/jfs/t1/73967/28/14561/916/5dc142e4E0666555b/bf33454553c6035e.png',
  });
};

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}
export default {
  version,
  locale,
  install,
  Lazyload,
  // VueQr,
  ...components,
  ...filters,
  ...directives,
  ...methods,
};
